import { apiRequest } from './api'

export interface PayloadUser {
  id: string
  email: string
  name?: string
  role?: string
}

export async function login(email: string, password: string): Promise<PayloadUser> {
  const data = await apiRequest<{ user: PayloadUser; token: string }>(
    '/api/users/login',
    {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    },
  )
  return data.user
}

export async function logout() {
  await apiRequest('/api/users/logout', { method: 'POST' })
}

export async function getMe(): Promise<PayloadUser | null> {
  try {
    const data = await apiRequest<{ user: PayloadUser }>('/api/users/me')
    return data.user
  } catch {
    return null
  }
}